import React from "react";
import {
    Box,
    FormControlLabel,
    Grid,
    InputAdornment,
    Switch,
    TextField,
} from "@material-ui/core";
import Filter from "../../../helpers/Filter";
import { FilterTags } from "../../../components/TagsAtentus/FilterTags";
import SearchIcon from "@mui/icons-material/Search";
import { t } from "i18next";
import { useTranslation } from "react-i18next";

export default function FilterInputs({
    tags,
    filterTagsType,
    autoPlaySlider,
    updateTags,
    stateFilter,
    changeStateFilter,
    changeAutoPlaySliderValue,
    searchTerm,
    handleSearchChange,
}) {
    const { t } = useTranslation();
    
    const filterList = [
        { nombre: t('flashboard-plus.status-fitler.options.Todos'), value: 'Todos' },
        { nombre: t('flashboard-plus.status-fitler.options.Activos'), value: 'Activos' },
        { nombre: t('flashboard-plus.status-fitler.options.Downtime-Global'), value: 'Downtime-Global' },
        { nombre: t('flashboard-plus.status-fitler.options.Downtime-Parcial'), value: 'Downtime-Parcial' },
        { nombre: t('flashboard-plus.status-fitler.options.Uptime'), value: 'Uptime' },
        { nombre: t('flashboard-plus.status-fitler.options.Umbral'), value: 'Umbral' },
        { nombre: t('flashboard-plus.status-fitler.options.No monitoreo'), value: 'No monitoreo' },
    ];

    const defaultValue = filterList.find(item => item.value === stateFilter)?.nombre || filterList[0].nombre;

    return (
        <Grid container spacing={3} style={{ marginTop: 20 }}>
            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <TextField
                    size="small"
                    fullWidth
                    label={t('flashboard-plus.input.search.label')}
                    placeholder={t('flashboard-plus.input.search.placeholder')}
                    variant="outlined"
                    value={searchTerm}
                    onChange={handleSearchChange}
                    InputProps={{
                        endAdornment: (
                            <InputAdornment position="end">
                                <SearchIcon />
                            </InputAdornment>
                        ),
                    }}
                    InputLabelProps={{
                        shrink: true,
                    }}
                />
            </Grid>
            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <Filter
                    list={filterList}
                    label={t('flashboard-plus.input.select-state.label')}
                    InfoAutoComplete={changeStateFilter}
                    placeholder={t('flashboard-plus.input.select-state.placeholder')}
                    default={defaultValue}
                />
            </Grid>
            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <FilterTags
                    listObjectives={[]}
                    updateEtiquetas={(etiqueta, filterType = "OR") =>
                        updateTags(etiqueta, filterType)
                    }
                    tagsId={tags}
                    preload={true}
                    filterTagsType={filterTagsType}
                    showFilterType={true}
                />
            </Grid>
            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <Box
                    display="flex"
                    justifyContent="end"
                    style={{ marginBottom: 30 }}
                >
                    <FormControlLabel
                        control={
                            <Switch
                                color="primary"
                                name="checkActivateAutoScroll"
                                checked={autoPlaySlider}
                                onChange={changeAutoPlaySliderValue}
                            />
                        }
                        label={t('flashboard-plus.input.autoplay.label')}
                    />
                </Box>
            </Grid>
        </Grid>
    );
}
